import React from 'react'

const SalesAnalysis:React.FC = () => {
  return (
    <div>
      Sales Analysis
    </div>
  )
}

export default SalesAnalysis;
